import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import PasoBar from "_+_Portal/_-_Autocheckin/components/genericos/PasoBar/PasoBar";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { useContext, useEffect, useState } from "react";
import {
  Paso4Body,
  Paso4Container,
  Paso4ContainerBotones,
  Paso4Titulo,
} from "../AbonarMP/localStyle";
import MercadoPagoLogo from "_+_Portal/assets/images/generico/MercadoPagoLogo";
import { IonSpinner } from "@ionic/react";
import { showToaster } from "global/context/action/toaster/toaster";
import { GlobalContext } from "global/context/Provider";
import {
  wsGetMercadoPagoLaboratorioQr,
  wsGetMercadoPagoReferencia,
} from "_+_Portal/context/Actions/mercadoPago/mercadoPago";
import { PortalContext } from "_+_Portal/context/Provider";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { Capacitor } from "@capacitor/core";
import { detectarIOS } from "global/utils/detectarIOS";

const AbonarTurnoLabo = () => {
  const [loading, setLoading] = useState(false);

  const { pasoDispatch, laboratorioState, puntoControlDispatch } =
    useContext(AutocheckContext);
  const { toasterDispatch, authState } = useContext(GlobalContext);
  const { selectDropDownState, mercadoPagoState, mercadoPagoDispatch } =
    useContext(PortalContext);
  const [initial, setInitial] = useState(true);
  const [deviceType] = useState(Capacitor.platform);

  const handleVolver = () => {
    setPaso("ResumenLabo")(pasoDispatch);
  };
  const turnosSeleccionados = laboratorioState.turnosSeleccionadosLabo?.data ?? [];
  const actual = laboratorioState.turnosSeleccionadosLabo?.actual ?? 0;
  const turno = turnosSeleccionados[actual];
  const monto = turno?.resumen?.monto;
  const bodyTxt =
    "Te falta un paso para finalizar la recepción de tu turno. El valor del mismo es de:";
  const bodyTxt2 =
    "(Seleccioná una opción para abonar. Recordá que por Mercadopago podés abonar con tarjeta de crédito y/o débito)";

  const isIOS = detectarIOS();
  const paciente = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
    : authState.auth?.data?.paciente;

  useEffect(() => {
    if (!initial && mercadoPagoState.mercadoPago.data) {
      loop();

      wsGetMercadoPagoReferencia(
        mercadoPagoState.mercadoPago.data.referenciaExterna
      )(mercadoPagoDispatch);
      const idWebservice = JSON.parse(
        mercadoPagoState.mercadoPago.data.idWebservice
      );
      if (isIOS) {
        if (deviceType !== "web") {
          window.location.href = idWebservice.initPoint;
        } else {
          window.open(idWebservice.initPoint, "_blank");
        }
      } else {
        window.open(idWebservice.initPoint, "_blank");
      }
    } else if (mercadoPagoState.mercadoPago.data) {
      loop();
    } else {
      setInitial(false);
    }
  }, [mercadoPagoState.mercadoPago.data]);

  let loop = () => {
    let count = 0;
    setLoading(true);
    let interval = setInterval(() => {
      let stopLoop = (isCorrect, data) => {
        data = JSON.parse(data.content);
        let condition =
          data.id !== 0 &&
          data.external_reference !== null &&
          data.status !== null &&
          data.initPoint !== null;
        // se debería borrar esto c
        if (isCorrect && condition) {
          // Debo llevar al próximo paso
          clearInterval(interval);
          setLoading(false);
          setPaso("CierreRecepcionLabo")(pasoDispatch);
        } else if (!isCorrect) {
          // Debo llevarlo al punto de control
          clearInterval(interval);
          const idTipoPuntoControl = 8;
          setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
          setPaso("PuntoControl")(pasoDispatch);
        }
      };
      wsGetMercadoPagoReferencia(
        mercadoPagoState.mercadoPago.data.referenciaExterna,
        stopLoop
      )(mercadoPagoDispatch);
      // Le consultamos si necesita más tiempo
      count++;
      if (count === 1) {
        clearInterval(interval);
        setPaso("TiempoExtraLabo")(pasoDispatch);
      }
    }, 5000);
  };

  const pagarEfectivo = () => {
    setPaso("EfectivoMp")(pasoDispatch);
  };
  const handleClickMP = () => {
    // Función para hacer que
    // se pague un turno
    const funLoading = (isCorrect) => {
      if (isCorrect) {
        setLoading(true);
      } else {
        setLoading(false);
        showToaster(
          {
            texto: "Hubo un error.",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        const idTipoPuntoControl = 8;
        setIdTipoPuntoControl(idTipoPuntoControl)(puntoControlDispatch);
        setPaso("PuntoControl")(pasoDispatch);
      }
    };

    setLoading(true);
    wsGetMercadoPagoLaboratorioQr(
      turno?.idProtocolo,
      funLoading
    )(mercadoPagoDispatch);
  };

  return (
    <LayoutPasos
      handleClick={handleVolver}
      type={"no-circle"}
      title={"AUTO CHECK IN"}
    >
      <CardBlueHeart
        medico={"Laboratorio"}
        turnoTitle={"Laboratorio"}
        pasoActual={actual + 1}
        pasoTotal={turnosSeleccionados.length}
      />

      <PasoBar paso={"AbonarMP"} />
      <Paso4Container>
        <Paso4Titulo>
          <span className="rb18m">Pago</span>
        </Paso4Titulo>
        <hr className="ValidaTurno-separador"></hr>
        <Paso4Body>
          <span className="ValidaTurno-bodytxt">{bodyTxt}</span>
          <div className="ValidaTurno-montoMercadoPago">
            <span className="rb48m">${monto}</span>
          </div>
          <span className="ValidaTurno-bodytxt">{bodyTxt2}</span>
        </Paso4Body>
        <Paso4ContainerBotones>
          <button
            className="btn btn-validaturno btn-outline-validaturno c-latex30"
            onClick={handleClickMP}
          >
            {loading ? (
              <span>
                <IonSpinner name="lines" />
              </span>
            ) : (
              <MercadoPagoLogo width={100} />
            )}
          </button>
          <button
            className="btn btn-validaturno btn-outline-validaturno  c-latex30 rb16m"
            onClick={pagarEfectivo}
          >
            Efectivo
          </button>
        </Paso4ContainerBotones>
      </Paso4Container>
    </LayoutPasos>
  );
};
export default AbonarTurnoLabo;
